<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <mat-card-title
              >{{
              "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.authentication_details"
              | translate }}</mat-card-title
            >
          </mat-card-header>
          <mat-card-content>
            <div fxFlex="100">
              <div fxLayout="row wrap" fxLayoutGap="20px grid">
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      [required]="isRequired('CrestMajorelUserName')"
                      formControlName="CrestMajorelUserName"
                      id="CrestMajorelUserName"
                      matInput
                      [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.user_name' |
                    translate"
                    />
                  </mat-form-field>
                </div>
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      [required]="isRequired('CrestMajorelPassword')"
                      formControlName="CrestMajorelPassword"
                      id="CrestMajorelPassword"
                      matInput
                      [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.password' |
                    translate"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <div fxFlex="20" class="u-text-left">
              <mat-card-title
                >{{
                "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.api_details"
                | translate }}</mat-card-title
              >
            </div>
            <div fxFlex="80" class="u-text-right">
              <button
                [disabled]="action=='view' || isEBasketSalesCrestMejorelAddDisabled"
                mat-flat-button
                color="primary"
                (click)="openEbasketCrestMajorelSelectApiPopup();"
              >
                {{ 'organization.module_assignment_tab.reason_code_tab.add' | translate}}
              </button>
            </div>
          </mat-card-header>
          <mat-card-content
            *ngFor="let apiDetails of parentForm?.get(authControlKey)?.get('ebasketSalesCrestMajorelApiDetails')['controls']; let i = index"
            formArrayName="ebasketSalesCrestMajorelApiDetails"
          >
            <div [formGroupName]="i">
              <div fxFlex="80">
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ apiDetails.value.selectedApi}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div fxLayout="row wrap" fxLayoutGap="20px grid">
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <input
                            formControlName="url"
                            id="ebasketMajorelURL"
                            matInput
                            [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.url' |
                    translate"
                          />
                        </mat-form-field>
                      </div>
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <mat-select
                            formControlName="method"
                            id="ebasketMajorelMethod"
                            [placeholder]="
                      'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.select_method' |
                      translate"
                          >
                            <mat-option
                              *ngFor="let methods of method_types"
                              [value]="methods.value"
                            >
                              {{methods.name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
              <div fxFlex="20" class="u-text-right">
                <button
                  [disabled]="action=='view'"
                  mat-flat-button
                  color="primary"
                  (click)="deleteEbasketSalesCrestMajorelApiDetailContainer(i);"
                >
                  {{ 'organization.create.section_4.customer_hub_section_1.delete' | translate}}
                </button>
              </div>
            </div>
          </mat-card-content>
          <div
            *ngFor="let apiDetails of parentForm?.get(authControlKey)?.get('ebasketSalesCrestMajorelApiDetails')['controls']; let i = index"
          >
            <mat-error
              *ngIf="(action !== 'view') && (!apiDetails.value.url || !apiDetails.value.method)"
            >
              {{ "organization.create.section_4.apiDetails_required" | translate }}
            </mat-error>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
